// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-BYtV","newExpiryDate":"styles_newExpiryDate__1aTD7","footer":"styles_footer__Z8fzF"};